// extracted by mini-css-extract-plugin
export default {"IconTooltip":"IconTooltip_IconTooltip__Lc3cG","Tooltip":"IconTooltip_Tooltip__zbBM+","TooltipWrap":"IconTooltip_TooltipWrap__+J6rb"};